/**
 * Created by Ram on 6/04/2017.
 */

import React, { Component } from "react";
import ClusterManagement from "../presentation/ClusterManagement";
import dynamicSort from "../../logic/DynamicSort";

class ClusterManagementWidget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      clusters: [],
      devices: [],
      clusterName: "",
      clusterComments: "",
      search: "",
      sort: "lastUpdateTime",
      sortAsc: false,
      sortDevices: "name",
      sortDevicesAsc: true,
      currentCluster: ""
    };
  }

  componentDidMount() {
    this.getClusterList();
  }

  updateSearchState = e => {
    this.setState({ search: e.target.value }, () => {
      this.getClusterList();
    });
  };

  getClusterDevices = (cluster, isEdiClicked) => {
    let devices = cluster.devices;
    this.setState({
      clusterName: cluster.name,
      clusterComments: cluster.comments,
      currentCluster: cluster
    });

    fetch(
      "/service/getClusterDevices?devices=" +
        devices +
        "&sortDevices=" +
        this.state.sortDevices +
        "&sortDevicesAsc=" +
        this.state.sortDevicesAsc,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin"
      }
    ).then(response => {
      if (response.status === 200) {
        response.json().then(devices => {
          this.setState({ devices }, () => {
            this.props.updateCluster(cluster, devices);
            if (isEdiClicked) {
              this.props.navigator.requestEditCluster();
            }
          });
        });
      }
    });
  };

  getClusterDetails = clusterId => {
    this.props.navigator.requestEditCluster(clusterId);
  };

  getClusterList = () => {
    this.setState({ isLoading: true }, () => {
      fetch(
        "/service/clusters?&sort=" +
          this.state.sort +
          "&search=" +
          this.state.search +
          "&sortAsc=" +
          this.state.sortAsc,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          credentials: "same-origin"
        }
      ).then(response => {
        if (response.status != 200) {
          response.json().then(json => {
            this.setState({ isLoading: false });
          });
        } else {
          response.json().then(clusters => {
            let clustersMapped = clusters.map(cluster => {
              cluster.numberDevices = cluster.devices.length;
              return cluster;
            });

            let clustersSorted = clustersMapped.sort(
              dynamicSort(this.state.sort, this.state.sortAsc ? 1 : -1)
            );
            this.setState({ clusters: clustersSorted, loading: false });

            if (clusters.length) {
              this.getClusterDevices(clustersSorted[0], false);
            }
          });
        }
      });
    });
  };

  updateSortState = sortBy => {
    if (sortBy === this.state.sort) {
      this.setState(
        prevState => ({ sortAsc: !prevState.sortAsc }),
        this.getClusterList
      );
    } else {
      this.setState({ sort: sortBy }, this.getClusterList);
    }
  };

  updateDevicesSortState = sortBy => {
    const callback = () =>
      this.getClusterDevices(this.state.currentCluster, false);
    if (sortBy === this.state.sortDevices) {
      this.setState(
        prevState => ({
          sortDevicesAsc: !prevState.sortDevicesAsc
        }),
        callback
      );
    } else {
      this.setState(
        {
          sortDevices: sortBy
        },
        callback
      );
    }
  };

  deleteCluster = clusterId => {
    if (confirm("Are you sure you want to delete this cluster?")) {
      fetch("/service/deleteCluster", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin",
        body: JSON.stringify({ clusterId: clusterId })
      }).then(response => {
        if (response.status != 200) {
          response.json().then(json => {
            this.setState({
              serverError: "Error! Cluster could not be deleted"
            });
          });
        } else {
          response.json().then(json => {
            alert(
              "Cluster  " + json.cluster.name + " has been deleted successfully"
            );
            this.props.navigator.requestClusterManagement();
          });
        }
      });
    }
  };

  render() {
    return (
      <ClusterManagement
        navigator={this.props.navigator}
        loadData={this.state}
        getClusterDevices={this.getClusterDevices}
        getClusterDetails={this.getClusterDetails}
        updateSearchState={this.updateSearchState}
        updateSortState={this.updateSortState}
        updateDevicesSortState={this.updateDevicesSortState}
        deleteCluster={this.deleteCluster}
      />
    ); //return
  } //render
} //ClusterManagementWidget

export default ClusterManagementWidget;
